import { default as app_45errorvP3UTS7RtEMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/app-error.vue?macro=true";
import { default as _91id_93gT6m9ddJTsMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsCast/[id].vue?macro=true";
import { default as indexlpBQu03x1lMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/guide/index.vue?macro=true";
import { default as indexioFEwb9uNFMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/help/index.vue?macro=true";
import { default as indexQUqUriYV3DMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/index.vue?macro=true";
import { default as index5aOZWFWKYdMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/player/index.vue?macro=true";
import { default as playerEdXXUrwNO2Meta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/player.vue?macro=true";
import { default as loaderqnoaDuuH6tMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/loader.vue?macro=true";
import { default as logomA1ELZJIjzMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/logo.vue?macro=true";
import { default as maxiDo8CNQC2CiMeta } from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/maxi.vue?macro=true";
export default [
  {
    name: "app-error",
    path: "/app-error",
    meta: app_45errorvP3UTS7RtEMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/app-error.vue").then(m => m.default || m)
  },
  {
    name: "detailsCast-id",
    path: "/detailsCast/:id()",
    meta: _91id_93gT6m9ddJTsMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsCast/[id].vue").then(m => m.default || m)
  },
  {
    name: "guide",
    path: "/guide",
    meta: indexlpBQu03x1lMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/guide/index.vue").then(m => m.default || m)
  },
  {
    name: "help",
    path: "/help",
    meta: indexioFEwb9uNFMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/help/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexQUqUriYV3DMeta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/index.vue").then(m => m.default || m)
  },
  {
    name: playerEdXXUrwNO2Meta?.name,
    path: "/player",
    meta: playerEdXXUrwNO2Meta || {},
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/player.vue").then(m => m.default || m),
    children: [
  {
    name: "player",
    path: "",
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/player/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "splash-loader",
    path: "/splash/loader",
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/loader.vue").then(m => m.default || m)
  },
  {
    name: "splash-logo",
    path: "/splash/logo",
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/logo.vue").then(m => m.default || m)
  },
  {
    name: "splash-maxi",
    path: "/splash/maxi",
    component: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/maxi.vue").then(m => m.default || m)
  }
]